import { Camera } from "../../base";
import { ThreeView } from "../View3dWebCad";
import { CameraPinPicture } from "./CameraPinPicture"

export class CameraPinManager { 
  
  private _pinPicture: CameraPinPicture;
  public _showPinPicture: boolean = false;

  constructor() {}

  /**
   * 吹き出しの作成
   */
  public createPinPicture(id: string, container: HTMLElement, object: THREE.Object3D) {
    this._pinPicture = new CameraPinPicture(id, container, object, ThreeView.get().eventDispatcher);
    this._showPinPicture = true;
  }

  /**
   * 吹き出しの削除
   */
  public remove() {
    this._showPinPicture = false;
    if (this._pinPicture != null) {
        this._pinPicture.removed();
        this._pinPicture = undefined;
    }
  }

  public visible(): boolean {
    return this._showPinPicture;
  }

  /**
   * 配置位置の更新
   */
  public update(position: THREE.Vector2) {
    this._pinPicture.update(position);
  }

  /**
   * 表示
   */
  public show() {
    this._showPinPicture = true;
  }

  /**
   * 非表示
   */
  public hide() {
    this._showPinPicture = false;
    if (this._pinPicture) {
        this._pinPicture.hide();
    }
  }

  public targetObject() {
      return this._pinPicture.getTargetObject();
  }

  public getPosition(object: THREE.Object3D, camera: Camera) {
    return this._pinPicture.positionFromObject(object, camera);
  }

}